import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroupDirective, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectBox } from 'cbc-shared-lib';
import { Sgke321aResponseWorkTntsh, Sgke903aResponseCompanyAreaInfo, Sgke903aResponseInitialhyojiInfo } from 'sg-api';
import { ListSearchUtils } from '../../../../../sg-ke-shared/util/list-search-utils';

@Component({
  selector: 'app-sgke320d-condition',
  templateUrl: './sgke320d-condition.component.html',
  styleUrl: './sgke320d-condition.component.scss'
})
export class Sgke320dConditionComponent implements OnInit, OnDestroy {

  /** 作業担当者 */
  @Input() workTntshList: Array<Sgke321aResponseWorkTntsh>;
  /** 会社地区情報 */
  @Input() cmpnyAreaList: Array<Sgke903aResponseCompanyAreaInfo>;
  /** 初期表示用会社地区情報 */
  @Input() cmpnyAreaInit: Sgke903aResponseInitialhyojiInfo;

  /** クリアボタン押下イベント */
  @Output() onClickClearEvent = new EventEmitter();
  /** 検索ボタン押下イベント */
  @Output() onClickSearchEvent = new EventEmitter();

  /** 会社コードリスト(S900020) */
  companycodeList: SelectBox[] = [];
  /** 地区（供給地点）リスト(S900030) */
  areaSuppntCodeList: SelectBox[] = [];
  /** 拠点コードリスト */
  baseList: SelectBox[] = [];
  /** 作業担当者名コードリスト */
  staffKanjiNameList: SelectBox[] = [];

  /** 親FormGroup */
  parentForm: UntypedFormGroup;
  /** 検索条件FormGroup */
  searchConditionForm: UntypedFormGroup;

  /**
   * コンストラクタ
   * @param {FormGroupDirective} parent
   * @param {UntypedFormBuilder} fb
   * @param {ChangeDetectorRef} cd
   * @param {ListSearchUtils} listSearchUtils
   * @memberof Sgke320dConditionComponent
   */
  constructor(
    private parent: FormGroupDirective,
    private fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
    private listSearchUtils: ListSearchUtils,
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke320dConditionComponent
   */
  ngOnInit() {
    // セレクターに値をセットする
    this.companycodeList.push(...this.getSelector('companycode', 'companycodeAname'));
    this.areaSuppntCodeList.push(...this.getSelector('areacode', 'areacodeAname'));
    this.baseList.push(...this.getKyotenSelector('baseCode', 'base'));

    this.searchConditionForm = this.fb.group({
      companycode: this.fb.nonNullable.control({ value: this.listSearchUtils.getListboxValue(this.cmpnyAreaInit.companycode, this.companycodeList), disabled: false }, Validators.required),
      areaSuppntCode: this.fb.nonNullable.control({ value: this.listSearchUtils.getListboxValue(this.cmpnyAreaInit.areacode, this.areaSuppntCodeList), disabled: false }, Validators.required),
      baseCode: this.fb.control({ value: null, disabled: false }),
      workTntsh: this.fb.control({ value: null, disabled: true }),
    });

    // FormGroupの登録
    this.parentForm = this.parent.form;
    // 親コンポーネントのformに検索条件formを追加
    this.parentForm.addControl("cndt", this.searchConditionForm);


    // 検索条件_作業担当者の活性切り替え
    this.changeList();
    this.cd.detectChanges();

  }

  /**
   * 購読解除
   * @memberof Sgke320dConditionComponent
   */
  ngOnDestroy() {
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    this.parentForm.removeControl('cndt');
  }

  /**
   * SGKE903Aレスポンスからセレクターにオプションをセット
   * @param {string} value
   * @param {string} viewValue
   * @return {*}
   * @memberof Sgke320dConditionComponent
   */
  getSelector(value: string, viewValue: string) {

    // SGKE903Aレスポンスのコードとコード値をまとめてリスト化
    let retSelectBoxList = this.cmpnyAreaList
      .map(data => {
        return { value: data[value], viewValue: data[viewValue] };
      })
      .reduce<SelectBox[]>((result, curr) => {
        const select = { value: curr[value], viewValue: curr[viewValue] }
        // 既に抽出済みでないものを追加
        if (!result.some((row) => row.value == curr.value)) {
          result.push(curr);
        }
        return result;
      }, [] as SelectBox[])
      .sort((a, b) => a.value > b.value ? 1 : -1);

    return retSelectBoxList;

  }

  /**
   * SGKE321Aレスポンスからセレクターにオプションをセット
   * @param {string} value
   * @param {string} viewValue
   * @return {*}
   * @memberof Sgke320dConditionComponent
   */
  getKyotenSelector(value: string, viewValue: string) {

    // SGKE321Aレスポンスのコードとコード値をまとめてリスト化
    let retSelectBoxList = this.workTntshList
      .map(data => {
        return { value: data[value], viewValue: data[viewValue] };
      })
      .reduce<SelectBox[]>((result, curr) => {
        const select = { value: curr[value], viewValue: curr[viewValue] }
        // 既に抽出済みでないものを追加
        if (!result.some((row) => row.value == curr.value)) {
          result.push(curr);
        }
        return result;
      }, [] as SelectBox[])
      .sort((a, b) => a.value > b.value ? 1 : -1);

    return retSelectBoxList;

  }

  /**
   * 検索ボタン押下時処理
   * @memberof Sgke320dConditionComponent
   */
  onClickSearch(): void {
    this.onClickSearchEvent.emit();
  }

  /**
   * クリアボタン押下時処理
   * @memberof Sgke320dConditionComponent
   */
  onClickClear(): void {
    // 拠点リストと作業担当者のみクリア
    this.getControl('baseCode').reset();
    this.getControl('workTntsh').reset();

    this.changeList();
    this.onClickClearEvent.emit();
  }

  /**
   * 検索条件_作業担当者の活性切り替え
   * [拠点選択時=活性] [非選択時=非活性]
   * @return {*}  {void}
   * @memberof Sgke320dConditionComponent
   */
  changeList(): void {
    // 拠点の選択状態
    let base = this.searchConditionForm.controls['baseCode']?.value;
    // 作業担当者のコントロール
    let control = this.searchConditionForm.controls['workTntsh'];

    control.reset();
    // 未選択 or 取得NGの場合
    if (base == undefined) {
      control.disable();
      return;
    } else {
      control.enable();
    }
  }

  /**
   * 拠点ドロップダウン変化時処理
   * @param {string} baseCode
   * @memberof Sgke320dConditionComponent
   */
  onChangeBase(baseCode: string) {
    // 拠点リストの値が変わった場合
    const staffKanjiNameCtl = this.getControl('workTntsh') as UntypedFormControl;
    staffKanjiNameCtl?.setValue(null);
    this.staffKanjiNameList = this.workTntshList
      .filter(list => list.baseCode == baseCode)
      .map(data => {
        const select: SelectBox = { value: data.staffCode, viewValue: data.staffKanjiName };
        return (select);
      });
  }

  /**
   * UntypedFormControl取得
   * @param {*} ctrlName
   * @return {*}  {UntypedFormControl}
   * @memberof Sgke320dConditionComponent
   */
  getControl(ctrlName): UntypedFormControl {
    return this.searchConditionForm.get(ctrlName) as UntypedFormControl;
  }

}
